<template>
  <div>
    <div class="page-title">New FAQ</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add FAQ"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.faqs.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Faq.new();
      this.form = data;
    },
    async create() {
      await this.$api.Faq.create(this.form);
      this.$router.push("/widgets/faqs");
    },
  },
};
</script>

<style></style>
